import {combineReducers} from 'redux';
import {UserState, userReducer} from './reducers/userReducer';
import {NotificationState, notificationReducer} from './reducers/notificationReducer';
import {CustomerState, customerReducer} from './reducers/customerReducer';
import {DashboardState, dashboardReducer} from './reducers/dashboardReducer';
import {WorkingTimeState, workingTimeReducer} from './reducers/workingTimeReducer';

export interface ReduxState {
    user: UserState;
    notification: NotificationState;
    customer: CustomerState;
    workingTime: WorkingTimeState;
    dashboard: DashboardState;
}

export const rootReducer = combineReducers({
    user: userReducer,
    notification: notificationReducer,
    customer: customerReducer,
    workingTime: workingTimeReducer,
    dashboard: dashboardReducer,
});
